module.exports = function() {
  return new Worker("/" + "pug-transpiler.6d85ee3d.worker.js");
};